import Handlebars from "handlebars";
import assetAttachmentTemplate from "./AssetAttachments.handlebars.js";

Handlebars.registerPartial('AssetAttachments', assetAttachmentTemplate);

const templateString=`<p>Hello there, </p> 
<p>&nbsp;</p> 
<p>Here's a collection of assets exclusively personalized for you! Hope you find this material useful.</p>  
<p>&nbsp;</p>
<p>I'd love to hear what you think about them. Please feel free to get in touch at any time.</p>  
<p>&nbsp;</p>
<p>&nbsp;</p>
<div class="mceNonEditable widget" data-widget-id="assets.grid">
  {{> AssetAttachments}}
</div>

<p>&nbsp;</p>
<p>&nbsp;</p>
<p><p class="variable mceNonEditable" data-original-variable="\\{{signature.description}}">signature</p>
<p>&nbsp;</p>`

const template = Handlebars.compile(templateString);
export default template;